<template>
	<div class="body">
		<div class="body-container">

			<div class="markdown-body" v-html="renderedContent"></div>

		</div>

		<div class="action-ctr" v-if="isDone">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">下载报告</el-button>
		</div>

	</div>
</template>

<script>
	import {
		streamJobReport,
		exportJobReport
	} from "@/api/service"

	import aiChatService from '@/utils/aiChat'

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	import {
		ref,
		onMounted
	} from 'vue'
	import {
		marked
	} from 'marked'
	import 'github-markdown-css' // 自带表格/图片/样式
	import 'highlight.js/styles/github.css'

	// 配置marked解析器（支持表格、图片、所有语法）
	marked.setOptions({
		gfm: true, // 开启GitHub标准markdown（表格必须开）
		breaks: true, // 换行转换
	})


	export default {
		name: "Famous",
		data() {
			return {
				title: '',
				base: '',
				skillList: [],
				ext: '',
				intro: '',
				params: {
					page: 1,
					pageSize: 20
				},
				loading: true,
				currentEventSource: null,
				isDone: false,
				renderedContent: '',
				fullContent: ''
			}
		},
		created() {
			this.initPageData();
		},

		beforeDestroy() {
			// 清理资源
			if (this.currentEventSource) {
				this.currentEventSource.close();
			}
			// aiChatService.cancelRequest();
		},


		methods: {
			initPageData() {
				this.streamData();
			},

			async streamData() {
				this.ids = this.$route.query.ids;
				this.params['ids'] = this.ids;
				this.isDone = false;

				try {
					// 使用流式对话
					await aiChatService.customeStream('service/streamJobReport', this.params, {
						onMessage: (chunk) => {
							console.log('onMessage chunk', chunk)
							// 1. 拼接新片段
							this.fullContent = chunk.data;

							// 2. 实时渲染为HTML（表格/图片/样式自动生成）
							this.renderedContent = marked.parse(this.fullContent)
						},

						onComplete: (data) => {
							console.log('对话完成onComplete:', data);
							Message({
								message: '已分析完成',
								type: 'success'
							})
						},

						onError: (error) => {
							console.log('error', error)
							this.$message.error('请求失败: ' + error);

						},

						onDone: () => {
							console.log('对话完成onDone:');
							this.isDone = true;
						},
					});

				} catch (error) {
					console.error('对话异常:', error);
				}
			},

			// 方法：格式化文本
			formatTextWithLineBreaks(text) {
				if (text) {
					text = text.replace(/；/g, '\n')
				}
				return text;
			},

			clickNext() {
				exportJobReport(this.params).then(res => {
					let realData = res.data;

					window.open(realData.url, '_blank')
				})
			}

		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "job_report.scss";
</style>